export default __webpack_public_path__ + "static/virtual_event-f502f363253f29691eff05de32c1aded.jpeg";